<template>

    <v-container fluid grid-list-md>
        <v-layout row wrap>

          <v-flex xs12 class="display-1 font-weight-light">
                MIDDLE MANAGER CURRICULUM
          </v-flex>

          <v-flex xs12 sm4 md2>

            <v-card height="100%">
              <v-img
                height="100%"
                :src="image"
                :lazy-src="image"
              ><template v-slot:placeholder>
                        <v-layout
                          fill-height
                          align-center
                          justify-center
                          ma-0
                        >
                          <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                        </v-layout>
                      </template>
              </v-img>
            </v-card>

          </v-flex>

          <v-flex xs12 sm8 md10>
            <p>Upon onboarding or promotion to a middle manager position, it is mandatory that you complete the initial requirement, the Middle Manager Course. This offering serves as a foundation in your quest to enhance personal and organizational leadership effectiveness.</p>
            <p>Middle Manager Course (MMC) must be completed within 12 months of promotion or onboarding.</p>
          </v-flex>



          <v-flex xs12 sm8 md10>

                <v-card
                  color="green"
                  dark
                  @click="openCourse('FAA01291')"
                  class="clickable"
                >
                  <v-card-title class="title">Middle Manager Course (MMC)</v-card-title>
                  <v-card-text class="white text--primary">

                    <v-layout>
                      <v-flex xs4>
                        <v-img
                          :src="require('@/assets/coursetype-ILT.png')"
                          height="125px"
                          contain
                        ></v-img>
                      </v-flex>
                      <v-flex xs8>
                        <p><strong>FORMAT</strong> Instructor-led Training (4.5 days)</p>
                        <p><em>NOTE: Must complete prior to taking Leadership for FAA Managers (LFM) WBT prerequisites.</em></p>
                      </v-flex>
                    </v-layout>
                    
  
                        <h3>Topics</h3>
                        <p><strong>Leading Self</strong></p>
                        <ul>
                          <li>Transitioning into a New Role</li>
                          <li>Fundamental Leadership Roles</li>
                          <li>Self-assessment</li>
                        </ul>
                        <p></p>
                        <p><strong>Leading Others</strong></p>
                        <ul>
                          <li>Leveraging Diversity</li>
                          <li>Labor Relations</li>
                          <li>Conduct and Discipline</li>
                          <li>Promoting Employee Performance</li>
                          <li>Conducting Employee Performance Appraisals</li>
                          <li>Handling Unacceptable Performance</li>
                        </ul>

                  </v-card-text>
                </v-card>

          </v-flex>

        </v-layout>
    </v-container>
</template>


<script>

export default{
  props: ['id'],
  data () {
        return {
        image: require('@/assets/middle_manager_curr.jpg')
    }
  },
  methods: {
    openCourseFromTable(item) {
      this.openCourse(item.id)
    },
    openCourse(id) {
      this.$router.push({ path: '/course/' + id });
    }
  }
}
</script>

<style>
.clickable {
  cursor: pointer;
}
</style>
